import createSaga from 'redux-saga';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './ducks';
import sagas from './sagas';

const sagaMiddleware = createSaga();
const middlewareApplied = applyMiddleware(sagaMiddleware);

const middlewares = (process.env.NODE_ENV === 'development')
  ? composeWithDevTools(middlewareApplied)
  : middlewareApplied;

const store = createStore(rootReducer, middlewares);
sagaMiddleware.run(sagas);

export default store;
